module.exports = __webpack_public_path__ + "img/u33.d9d405d6.png";